import { useMemo, useState } from "react";
import { HashConnectTypes } from "hashconnect";
import { ConnectType } from "context/HashConnectProvider";
import { WalletConnectModalBody } from "ui";
import bladeIcon from "assets/blade.png";
import hashpackIcon from "assets/hashpack.png";
import { StorageService } from "services/storage.service";

// firebase analytics
// import { trackEvent } from "utils/firebase";
// import { SELECTED_WALLET } from "constants/analytics";
import { firebaseEvents } from "utils/firebase";
import { FIREBASE_EVENT_PROPERTIES } from "constants/constants";

type WailetsConfig = {
  availableInstallTypes: Array<ConnectType>;
};

function useWallet(): WailetsConfig {
  return {
    availableInstallTypes: [ConnectType.CHROME_EXTENSION],
  };
}
interface WalletConnectProps {
  isWalletDisconnected: boolean;
  installedExtensions: HashConnectTypes.WalletMetadata | null;
  isWalletInitializing: boolean;
  isBladeExtensionInstalled: boolean;
  installWallet: (props: ConnectType) => void;
}

const WalletConnect = (props: WalletConnectProps) => {
  const { installWallet } = props;
  const [termAccepted, setTermAccepted] = useState(StorageService.getTerms());
  const sendLog = (name: string) => {
    let firebaseRequest: any = {
      [FIREBASE_EVENT_PROPERTIES.EVENT_NAME]: name,
    };
    firebaseEvents(firebaseRequest);
  };
  const toggle = () => {
    StorageService.saveTerms(!termAccepted);
    setTermAccepted(!termAccepted);
    sendLog("Accpet_TOS_Checkbox");
  };

  const wallet = useWallet();
  const {
    isWalletDisconnected,
    installedExtensions,
    isWalletInitializing,
    isBladeExtensionInstalled,
  } = props;

  const wallets = useMemo(() => {
    const wallets = [];
    if (wallet.availableInstallTypes.includes(ConnectType.CHROME_EXTENSION)) {
      wallets.push({
        key: "HASHPACK",
        label:
          isWalletDisconnected && installedExtensions !== null
            ? "HashPack Wallet"
            : isWalletInitializing
            ? "Initializing Wallet..."
            : "Install HashPack Extension",
        connect: () => {
          // trackEvent(SELECTED_WALLET, { wallet_type: "hashpack" });
          !isWalletInitializing &&
            installWallet(
              isWalletDisconnected && installedExtensions !== null
                ? ConnectType.CHROME_EXTENSION
                : ConnectType.INSTALL_EXTENSION
            );
        },
        icon: hashpackIcon,
      });
    }

    // blade wallet
    wallets.push({
      key: "BLADE",
      label: isWalletInitializing ? (
        "Initializing Wallet..."
      ) : (
        <>
          {isBladeExtensionInstalled ? "" : "Install"} Blade
          {isBladeExtensionInstalled ? " Wallet" : " Extension"}
        </>
      ),
      connect: () => {
        // trackEvent(SELECTED_WALLET, { wallet_type: "blade" });
        installWallet(ConnectType.BLADE_WALLET);
      },
      icon: bladeIcon,
    });

    return wallets;
  }, [
    isWalletInitializing,
    isWalletDisconnected,
    installedExtensions,
    isBladeExtensionInstalled,
  ]);

  return (
    <WalletConnectModalBody
      walletMenuOptions={wallets as any}
      toggle={toggle}
      termAccepted={termAccepted}
    />
  );
};

export default WalletConnect;
